import React, { Suspense, lazy } from 'react';
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'wx-open-launch-app': any;
    }
  }
}

const MemberIndex = lazy(
  () => import(/* webpackChunkName: "MemberIndex" */ './pages/MemberIndex')
);

const MemberSubscriptionPage = lazy(
  () =>
    import(
      /* webpackChunkName: "MemberSubscriptionPage" */ './pages/MemberSubscriptionPage'
    )
);

const GxMemberSubscriptionPage = lazy(
  () =>
    import(
      /* webpackChunkName: "GxMemberSubscriptionPage" */ './pages/GxMemberSubscriptionPage'
    )
);

const AppsMemberSubscriptionPage = lazy(
  () =>
    import(
      /* webpackChunkName: "AppsMemberSubscriptionPage" */ './pages/AppsMemberSubscriptionPage'
    )
);

const MonthlySubscriptionProtocolPage = lazy(
  () =>
    import(
      /* webpackChunkName: "MonthlySubscriptionProtocolPage" */ './pages/MonthlySubscriptionProtocolPage'
    )
);

const MemberServiceProtocolPage = lazy(
  () =>
    import(
      /* webpackChunkName: "MemberServiceProtocolPage" */ './pages/MemberServiceProtocolPage'
    )
);

const ReceiveWeekMemberPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ReceiveWeekMemberPage" */ './pages/ReceiveWeekMemberPage'
    )
);

const ReceiveMonthMemberPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ReceiveMonthMemberPage" */ './pages/ReceiveMonthMemberPage'
    )
);

const MemberAppAlertPage = lazy(
  () =>
    import(
      /* webpackChunkName: "MemberAppAlertPage" */ './pages/MemberAppAlertPage'
    )
);

const MemberBackPagePage = lazy(
  () =>
    import(
      /* webpackChunkName: "MemberBackPagePage" */ './pages/MemberBackPagePage'
    )
);
const ReceiveWordbook = lazy(
  () =>
    import(/* webpackChunkName: "ReceiveWordbook" */ './pages/ReceiveWordbook')
);

const MemberActivityPage = lazy(
  () =>
    import(
      /* webpackChunkName: "MemberActivityPage" */ './pages/MemberActivityPage'
    )
);

const ContractManagePage = lazy(
  () =>
    import(
      /* webpackChunkName: "ContractManagePage" */ './pages/ContractManagePage'
    )
);

const RecallActivityPage = lazy(
  () =>
    import(
      /* webpackChunkName: "RecallActivityPage" */ './pages/RecallActivityPage'
    )
);

const App: React.FC = () => {
  return (
    <>
      <Router>
        <Suspense fallback={<div />}>
          <Switch>
            <Redirect
              exact
              path="/"
              to={{ pathname: '/member-subscription' }}
            />
            <Route
              exact
              path="/member-subscription"
              component={() => <MemberIndex />}
            />
            <Route
              exact
              path="/gx-member-subscription"
              component={() => <GxMemberSubscriptionPage />}
            />
            <Route
              exact
              path="/apps-member-subscription"
              component={() => <AppsMemberSubscriptionPage />}
            />
            <Route
              exact
              path="/monthly-subscription-protocol"
              component={() => <MonthlySubscriptionProtocolPage />}
            />
            <Route
              exact
              path="/member-service-protocol"
              component={() => <MemberServiceProtocolPage />}
            />
            <Route
              exact
              path="/receive-week-member"
              component={() => <ReceiveWeekMemberPage />}
            />
            <Route
              exact
              path="/receive-month-member"
              component={() => <ReceiveMonthMemberPage />}
            />
            <Route
              exact
              path="/app-alert"
              component={() => <MemberAppAlertPage />}
            />
            <Route
              exact
              path="/member-back"
              component={() => <MemberBackPagePage />}
            />
            <Route
              exact
              path="/receive-wordbook"
              component={() => <ReceiveWordbook />}
            />
            <Route
              exact
              path="/member-activity"
              component={() => <MemberActivityPage />}
            />
            <Route
              exact
              path="/contract-manage"
              component={() => <ContractManagePage />}
            />
            <Route
              exact
              path="/recall-activity"
              component={() => <RecallActivityPage />}
            />
          </Switch>
        </Suspense>
      </Router>
    </>
  );
};
export default App;
